require('../common.js')
//
var params = urlparser(window.location.href);
var categoryId = params.get('categoryId', ''); // 类别id
// 查列表页广告
// 首页品牌广告
$.get({url: '/ad/classifyAd.html', contentType: 'text/html', loading: false}).success(function (res) {
    $('#ad').html(res)
})

//
function Model(brands, categories) {
    var self = this;
    this.base = '/product/';
    this.sorts = [{name: '默认', value: '', checked: ko.observable(true)}, {
        name: '价格',
        value: 'price',
        checked: ko.observable(false)
    }]
    this.brands = $.map(brands, function (e) {
        e.checked = ko.observable(false);
        return e;
    });
    this.brands.unshift({name: '全部', checked: ko.observable(true)});
    //
    this.categories = $.map(categories, function (e) {
        e.checked = ko.observable(categoryId == e.id);
        return e;
    });
    this.categories.unshift({name: '全部', checked: ko.observable(!!!categoryId)});
    //
    var levels = [{id: 'A', name: 'A类'}, {id: 'B', name: 'B类'}, {id: 'C', name: 'C类'}, {id: 'D', name: 'D类'}];
    this.levels = $.map(levels, function (e) {
        e.checked = ko.observable(false);
        return e;
    })
    this.levels.unshift({name: '全部', checked: ko.observable(true)});
    //
    this.switchBrand = function (brand) {
        $.each(self.brands, function () {
            this.checked(false)
        })
        brand.checked(true)
        self.brandId(brand.id)
    };
    this.switchCategory = function (category) {
        $.each(self.categories, function () {
            this.checked(false)
        })
        category.checked(true)
        self.categoryId(category.id)
    };
    this.switchLevel = function (level) {
        $.each(self.levels, function () {
            this.checked(false)
        });
        level.checked(true);
        self.level(level.id)
    };
    this.switchSort = function (sort) {
        $.each(self.sorts, function () {
            this.checked(false);
        });
        sort.checked(true);
        self.sort(sort.value);
    };
    this.switchPage = function (page) {
        $.each(self.pages(), function () {
            this.checked(false);
        });
        page.checked(true);
        self.page(page.value);
    };
    //
    this.pages = ko.observableArray([]); // 页码
    this.page = ko.observable(0); // 默认第一页
    this.sort = ko.observable(''); // 排序条件
    this.categoryId = ko.observable(categoryId);
    this.brandId = ko.observable('');
    this.level = ko.observable(''); // 优惠级别
    this.products = ko.observableArray([]);
    this.last = ko.observable(0);
    this.pre = function () {
        var page = self.page();
        var totalPages = self.last();
        if (page > 0) {
            self.switchPage(this.pages()[page - 1])
        }
    }
    this.next = function () {
        var page = self.page();
        var totalPages = self.last();
        if (page < totalPages) {
            self.switchPage(this.pages()[page + 1])
        }
    }
    this.switchPage = function (page) {
        $.each(self.pages(), function () {
            this.checked(false);
        })
        page.checked(true);
        self.page(page.value);
    }

    // callback
    function callback() {
        $.get(hostsetter('products'), {
            page: 0,
            sort: self.sort(),
            brandId: self.brandId(),
            level: self.level(),
            categoryId: self.categoryId(),
            enabled: true,
            size: 15
        }).success(function (res) {
            self.products(res.data.content)
            var page = res.data.totalPages;
            var pages = [];
            for (var i = 1; i <= page; i++) {
                pages.push({page: i, value: i - 1, checked: ko.observable(i === 1)});
            }
            self.pages(pages);
            self.last(page - 1);
        })
        return 0;
    }

    //
    this.sort.subscribe(callback);
    this.categoryId.subscribe(callback);
    this.brandId.subscribe(callback);
    this.level.subscribe(callback);
    this.page.subscribe(function () {
        $.get(hostsetter('products'), {
            page: self.page(),
            sort: self.sort(),
            brandId: self.brandId(),
            level: self.level(),
            categoryId: self.categoryId(),
            enabled: true,
            size: 15
        }).success(function (res) {
            self.products(res.data.content)
        })
    })
    //
    callback()
}

//
// context.memberOrLogin(function(member) {
var categoryDeferred = $.Deferred(function (deferred) {
    $.get(hostsetter('/categories/all')).success(function (categories) {
        deferred.resolve(categories)
    })
})
var brandDeferred = $.Deferred(function (deferred) {
    $.get(hostsetter('/brands/all')).success(function (brands) {
        deferred.resolve(brands)
    })
})
//
$.when(categoryDeferred, brandDeferred).then(function (categories, brands) {
    var vm = new Model(brands, categories);
    ko.applyBindings(vm, $('#content')[0]);
})
// })
//style
require('../../less/j_style.less');



/*****************
 ** WEBPACK FOOTER
 ** ./controller/product/Classify.js
 ** module id = 0
 ** module chunks = 3
 **/